import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Container, Typography, alpha } from '@mui/material';
import FondoHero from '../img_icons/FondoHero.mp4';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { useNavigate } from "react-router-dom";
import VideoPlay from './VideoPlay';

const Hero = () => {
  const [infoInicio, setInfoInicio] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleContactClick = () => {
    navigate('/contactanos-page-web');
  };

  useEffect(() => {
    onSnapshot(collection(db, 'infoiniciocalocho'),
        (snapshot) => {
            const arregloInfoInicio = snapshot.docs.map((docInfoInicio) => {
                return {...docInfoInicio.data(), id: docInfoInicio.id};
            })

            setInfoInicio(arregloInfoInicio);
            setLoading(false); // Data has been loaded
          },
        (error) => {
            console.log(error);
        }
      );
  }, []);

  // Carrusel: Actualizar el índice cada 10 segundos
  useEffect(() => {
    if (infoInicio.length > 1) {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % infoInicio.length);
        }, 10000); // 10000ms = 10s
        return () => clearInterval(interval);
    }
}, [infoInicio.length]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress sx={{ color: '#5d0303' }} />
      </Box>
    );
  }

  if (infoInicio.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Typography variant="h6">No hay datos por mostrar</Typography>
      </Box>
    );
  }

  return (
    infoInicio.length > 0 &&
    <Box
      id="hero"
      sx={(theme) => ({
        width: '100%',
        height: '100vh', // Ajusta la altura a la pantalla completa
        backgroundImage:
          theme.palette.mode === 'light'
            ? 'linear-gradient(180deg, #5d0303, #5d0303)'
            : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        textAlign: 'center',
        color: '#fff',
        overflow: 'hidden', // Para asegurar que no haya desbordamiento
      })}
    >

      <VideoPlay />

      <Container key={infoInicio[currentIndex].id}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 10, sm: 12, md: 14 },  // Espaciado superior para diferentes pantallas
          pb: { xs: 6, sm: 8, md: 10 },  // Espaciado inferior
          zIndex: 2,
          backgroundImage: `url(${FondoHero})`, // El fondo se adapta al contenedor
          backgroundSize: 'cover', // Ajuste del tamaño de la imagen de fondo
          backgroundPosition: 'center', // Centrar la imagen de fondo
        }}
      >

        <Typography variant="h5" sx={{ 
          letterSpacing: '0.2em', 
          marginBottom: '10%',
          opacity: 0.7, 
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
          fontSize: { xs: '0.9rem', sm: '1.5rem', md: '2rem' },
        }}>
          {infoInicio[currentIndex].subtitulo}
        </Typography>

        <Typography
          variant="h1"
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '3.5rem' },
            my: 2,
            letterSpacing: '0.05em',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)' // Añade esta línea
          }}
        >
          {infoInicio[currentIndex].titulo}
        </Typography>
        <Button
          variant="outlined"
          sx={{
            border: 'solid #fff 2px',
            color: '#fff',
            fontSize: { xs: '1rem', sm: '1.2rem' },  // Escala del tamaño de la fuente
            padding: { xs: '0.6rem 1.5rem', sm: '0.8rem 2rem' },  // Ajuste dinámico de padding
            borderRadius: '50px',
            top: 100,
            mt: 4,
            ':hover': {
              backgroundColor: '#5d0303',
            },
            width: { xs: '90%', sm: 'auto' },  // Ancho completo en móviles, automático en pantallas grandes
          }}
          onClick={handleContactClick}
          size="small"
        >
          Contáctame ahora
        </Button>
      </Container>
    </Box>
  );
}

export default Hero;